export enum AccessRules {
  visible = "visible",
  owner = "owner",
  none = "none",
}

export type PermissionTier = "medical" | "monitoring";

export interface TableAccess {
  readonly editRules: Record<PermissionTier, AccessRules>;
  readonly deleteRules: Record<PermissionTier, AccessRules>;
  readonly historyRequiresMonitoring: boolean;
}
